import { DynamicDocumentGroup } from '@/types';

import retrofit from '../document.retrofit.json';
import serviceQuestionnaire from '../document.service-questionnaire.json';

/**
 * The questionnaire an assignment is reported on, by opdrachtsoort.
 *
 * Mirrors the installation side's `dynamic-documents.ts`, which keys the delivery documents by
 * module type — the same "several question sets, pick one at runtime" shape, one level up.
 *
 * Every service soort shares one vragenlijst, because what a monteur has to record is the same
 * whatever triggered the call. Retrofit is the counterexample: genuinely different work, so its own
 * opleverformulier. A soort nobody has listed falls back to the service vragenlijst, which is what
 * every assignment in mech v2 was reported on before this registry existed.
 */
const FORMS: Record<string, DynamicDocumentGroup[]> = {
  retrofit: retrofit as DynamicDocumentGroup[],
};

export const SERVICE_QUESTIONNAIRE = serviceQuestionnaire as DynamicDocumentGroup[];

export function templateFor(type?: string): DynamicDocumentGroup[] {
  return (type && FORMS[type]) || SERVICE_QUESTIONNAIRE;
}
